export default __webpack_public_path__ + "static/media/4.191d1c61.svg";